function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "Bars Copy");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Invision",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Bars-Copy",
  transform: "translate(0.000000, 0.906250)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.714285714,1.42857143 L19.2857143,1.42857143 C19.6805355,1.42857143 20,1.10910688 20,0.754464013 C20,0.399821145 19.6785709,0 19.2857143,0 L0.714285714,0 C0.319464547,0 0,0.319643021 0,0.674107415 C0,1.02857045 0.319464547,1.42857143 0.714285714,1.42857143 Z M19.2857143,7.14285714 L0.714285714,7.14285714 C0.319464547,7.14285714 0,7.46428558 0,7.85714286 C0,8.24999946 0.319464547,8.57142857 0.714285714,8.57142857 L19.2857143,8.57142857 C19.6785709,8.57142857 20,8.24999946 20,7.85714286 C20,7.46428626 19.6785709,7.14285714 19.2857143,7.14285714 Z M19.2857143,14.2857143 L0.714285714,14.2857143 C0.319464547,14.2857143 0,14.6051788 0,14.9598217 C0,15.3144646 0.319464547,15.7142857 0.714285714,15.7142857 L19.2857143,15.7142857 C19.6805355,15.7142857 20,15.3948212 20,15.0401783 C20,14.6855354 19.6785709,14.2857143 19.2857143,14.2857143 Z",
  id: "Shape"
})));
const SvgIconBars = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "17px",
    viewBox: "0 0 20 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBars, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-bars.6ee20366.svg";
export { ForwardRef as ReactComponent };